import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next'; // Import useTranslation

// Replace these with your actual image paths
import img1 from '../assets/right.png';
import img2 from '../assets/right1.png';
import img3 from '../assets/right2.png';

const phoneImages = [img1, img2, img3];

export const Features: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { t } = useTranslation(); // Initialize useTranslation hook

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % phoneImages.length);
    }, 3000); // 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative flex flex-col lg:flex-row min-h-[500px] text-gray-800">
      {/* Left Half: Text Content */}
      <div className="lg:w-1/2 flex items-center justify-center p-8 md:p-12 lg:p-16">
        <div className="max-w-xl text-center lg:text-left">
          <span className="bg-gradient-to-r from-blue-600 to-green-500 bg-clip-text text-transparent font-semibold text-lg mb-2 block">
            {t('features_new_label')} {/* Translated */}
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold leading-tight mb-6">
            <span className="bg-gradient-to-r from-blue-600 to-green-500 bg-clip-text text-transparent">
              {t('features_heading')} {/* Translated */}
            </span>
          </h2>
          <p className="text-lg md:text-xl text-gray-700 mb-8">
            {t('features_description')} {/* Translated */}
          </p>
          <a
            href="#"
            className="inline-flex items-center bg-gradient-to-r from-blue-600 to-green-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:brightness-110 transition-all duration-300 shadow-xl"
          >
            {t('try_coc_free_button')} {/* Translated */}
          </a>
        </div>
      </div>

      {/* Right Half: Gradient Background with Phone Mockup */}
      <div className="lg:w-1/2 bg-gradient-to-br from-blue-700 to-green-600 flex items-center justify-center p-8 md:p-12 lg:p-16 relative overflow-hidden">
        {/* Subtle background pattern */}
        <div
          className="absolute inset-0 z-0 opacity-10 "
          style={{
            backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.15) 2px, transparent 2px)',
            backgroundSize: '45px 45px',
          }}
        ></div>

        {/* Phone Screen Carousel */}
        <div className="relative w-[300px] h-[400px] md:h-[450px] rounded-[2rem] overflow-hidden shadow-2xl bg-black">
          <AnimatePresence mode="wait">
            <motion.img
              key={currentIndex}
              src={phoneImages[currentIndex]}
              alt={t('features_phone_ui_alt', { index: currentIndex + 1 })} 
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -100 }}
              transition={{ duration: 0.5 }}
              className="w-full h-full object-cover"
            />
          </AnimatePresence>

          {/* Bottom bar of phone */}
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-28 h-1.5 bg-gray-700 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};